module.exports = __webpack_public_path__ + "img/phenix-fire-logo.dfad9aac.jpg";